export default __webpack_public_path__ + "static/media/eye_on.9a54fd1a.svg";